import { render, staticRenderFns } from "./UserCouponUsedStatDrawer.vue?vue&type=template&id=0355ecd6&scoped=true"
import script from "./UserCouponUsedStatDrawer.vue?vue&type=script&lang=js"
export * from "./UserCouponUsedStatDrawer.vue?vue&type=script&lang=js"
import style0 from "./UserCouponUsedStatDrawer.vue?vue&type=style&index=0&id=0355ecd6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0355ecd6",
  null
  
)

export default component.exports